import PropTypes from "prop-types";

function SortableHeader({ column, label, sortBy, sortDir, onSort, className }) {
  const isActive = sortBy === column;
  const iconClass = isActive ? `fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1` : "fa fa-sort ms-1 text-muted";
  return (
    <th className={className} style={{ cursor: "pointer", userSelect: "none" }} onClick={() => onSort(column)}>
      {label}
      <i className={iconClass} />
    </th>
  );
}

SortableHeader.propTypes = {
  column: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDir: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default SortableHeader;
